import { dequal } from 'dequal';

export const isJsonEqual = (left: unknown, right: unknown): boolean => {
  const normalize = (value: unknown) => JSON.parse(JSON.stringify(value ?? null));
  return dequal(normalize(left), normalize(right));
};

export type Comparator = 'gt' | 'gte' | 'lt' | 'lte' | 'eq';

export function compareValues<T extends string | number | boolean>(
  value1: T,
  comparator: Comparator,
  value2: T
): boolean {
  switch (comparator) {
    case 'lt':
      return value1 < value2;
    case 'lte':
      return value1 <= value2;
    case 'gt':
      return value1 > value2;
    case 'gte':
      return value1 >= value2;
    case 'eq':
      return value1 === value2;
    default:
      return false;
  }
}
